import React, { Component } from 'react';
import { notification } from 'antd';
import { accountLogin, getAESKey } from '@/api/login';
import { updateCookie } from '../../utils/index';
import { encryptAES } from '@/utils/index';
import message from '@/components/Toast';
class AutoLogin extends Component {
    async componentDidMount() {
        // const BI = localStorage.getItem('BI');
        let userInfo = { name: 'livestat', password: 'f8EvJhfEbHrJ8ea' };

        // if (BI.username && BI.password) {
        //     userInfo = { name: BI.username, password: BI.password };
        // }

        const aesKeyRes = await getAESKey();
        if (aesKeyRes.code === '00000') {
            userInfo.password = encryptAES(userInfo.password, aesKeyRes.data.aes_key);
            userInfo.aes_key_id = aesKeyRes.data.aes_key_id;
        } else {
            return message.error(aesKeyRes.msg || '服务请求发生错误');
        }

        const { success, data, msg } = await accountLogin(userInfo);

        if (success) {
            updateCookie(Object.assign(data, { domain: window.location.host }));
            if (location.search) {
                let next = location.search.slice(1).split('=')[1];

                window.location.href = next;
            } else {
                window.location.href = '/operate';
            }
        } else {
            notification.error({
                message: '操作异常',
                description: msg || '未知的错误'
            });
        }
    }

    render() {
        return <div>自动登录中...</div>;
    }
}

export default AutoLogin;
